import * as St from './index.styled';
import { WegetSelectBackupds } from './wegets/weget-select-backups';

export function MainView(props){
    const handleFetchBackupRackLocations = async () => {
        console.log('fetching backup rack locations');
    }
    
    return (
        <>
            <WegetSelectBackupds />
        </>
    );
}